import { Link, useLocation } from "react-router-dom";
import { linkArray, roleNames } from "../constant";
import Navlink from "../common/FormInputs/Navlink";
import { useSelector } from "react-redux";
import { logOut } from "../services/api";
import useExpiredToken from "../utils/useExpiredToken";
import { useToast } from "../utils/Toast";
import { useState } from "react";
import DeleteModal from "./models/DeleteModal";
import { useLoader } from "../contexts/LoaderContext";

const Sidebar = () => {
  const { pathname } = useLocation();
  const role = useSelector((state) => state.auth.role);
  const token = useSelector((state) => state.auth.jwtToken);
  const expireToken = useExpiredToken();
  const toast = useToast();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const { showLoader, hideLoader } = useLoader();

  const handleLogout = async () => {
    showLoader();
    const res = await logOut("auth/logout", token, {});
    if (res) {
      toast.success(res.data);
      setTimeout(() => {
        expireToken();
      }, 300);
    }
    hideLoader();
  };

  const topLinks = linkArray.slice(0, 6).filter((item) => {
    if (role === roleNames.qa) {
      return item.title !== "Assign calls" && item.title !== "Manage QAs";
    }
    return true;
  });

  const bottomLinks = linkArray.slice(6);

  return (
    <>
      <nav id="sidebar">
        <div className="logo">
          <Link to="/">
            <img src="/assets/logo.png" alt="Logo" width={150} />
          </Link>
        </div>
        <div className="innerset">
          <div>
            <nav className="nav">
              {topLinks &&
                topLinks?.map((item, i) => (
                  <Navlink
                    key={i}
                    pathname={pathname}
                    item={item}
                    role={role}
                    handleLogout={handleLogout}
                  />
                ))}
            </nav>
          </div>
          <div className="bottom-links">
            {bottomLinks &&
              bottomLinks?.map((item, i) => (
                <Navlink
                  key={i}
                  pathname={pathname}
                  item={item}
                  role={role}
                  handleLogout={() => setShowLogoutConfirm(true)}
                />
              ))}
          </div>
        </div>
      </nav>
      <DeleteModal
        open={showLogoutConfirm}
        handleCancel={() => setShowLogoutConfirm(false)}
        handleDelete={handleLogout}
        title={"Log out?"}
        description={
          "You’ll be signed out of your admin panel. Don’t worry — all your work is saved."
        }
        confirmButtonText={"Log out"}
      />
    </>
  );
};

export default Sidebar;
